import { Table, TableBody, TableCell, TableHead, TableRow } from "../../common/components/Table/TableElements";
import classes from "../BearingFrequencyCalculator.module.less";
import { NumberFormatter } from "../../utils/NumberFormatter";
import { type BearingFrequencyCalculationResult } from "../calculateBearingFrequency";
import { useTranslation } from "react-i18next";

const RESULT_NF = NumberFormatter.getFormatter({
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

interface TableProps {
  result: BearingFrequencyCalculationResult | null;
}

export function TableBFC({ result }: TableProps) {
  const { t } = useTranslation();
  const renderResultRow = (resultDescKey: string, resultVal: number | null | undefined) => {
    let val, suffix;
    if (typeof resultVal === "number") {
      val = RESULT_NF.format(resultVal);
      suffix = "Hz";
    } else {
      val = "-";
      suffix = "";
    }
    return (
      <TableRow>
        <TableCell dangerouslySetInnerHTML={{ __html: t(resultDescKey) }} />
        <TableCell align={"right"} className={classes.tableResultValue}>{`${val} ${suffix}`}</TableCell>
      </TableRow>
    );
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t("bearingFrequencyCalculator.table.header")}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {renderResultRow("bearingFrequencyCalculator.table.overrolingInner", result?.ir)}
        {renderResultRow("bearingFrequencyCalculator.table.overrolingOuter", result?.or)}
        {renderResultRow("bearingFrequencyCalculator.table.rollingElement", result?.re)}
        {renderResultRow("bearingFrequencyCalculator.table.cageInner", result?.cir)}
        {renderResultRow("bearingFrequencyCalculator.table.cageOuter", result?.cor)}
      </TableBody>
    </Table>
  );
}
